import { createConsumer } from "@rails/actioncable"

// One WebSocket for the whole page, shared by every channel-subscribing
// controller. A controller that calls createConsumer() itself opens a new
// socket per connect() — harmless with a single subscriber today, but the
// wrong template to copy the moment a second channel shows up (Turbo
// disconnecting/reconnecting the element would pile up sockets instead of
// adding a subscription to the one already open).
export default createConsumer()
